/* eslint no-underscore-dangle: [error, { allow: [_id] }] */
import React from 'react';
import PropTypes from 'prop-types';
import MemberImage from '../member/MemberImage';
import MemberName from '../member/MemberName';
import VoteButtons from './VoteButtons';
import Time from '../../../legacy/flux/components/misc/Time.react';
import ImageSvg from '../image/ImageSvg';
import cx from '../../utils/cx';

const MatchesMembersItem = (props) => {
  const {
    member,
    action,
    updated,
    handleVote,
    includeSkip,
    unseen,
    noAboLimitReached,
  } = props;

  if (!member) {
    return (null);
  }

  const myAction = () => {
    if (action === 'like') {
      return (
        <div>
          Tev
          <span className="tcg"> patīk</span>
        </div>
      );
    }

    if (action === 'dislike') {
      return (
        <div>
          Tev
          <span className="tcr"> nepatīk</span>
        </div>
      );
    }

    if (action === 'skip' && includeSkip) {
      return (
        <div>
          Tu
          <span className="tch"> izlaidi (uz 1 dienu)</span>
        </div>
      );
    }

    return (null);
  };

  const onVote = (newVote) => {
    handleVote(member._id, newVote);
  };

  const activityIcon = () => {
    let icon = 'heartempty';
    if (member.match) {
      icon = 'heart';
    } else if (member.liked) {
      icon = 'hearthalfleft';
    } else if (member.likes_me) {
      icon = 'hearthalfright';
    }

    return (
      <span className="activityItem-icon">
        <ImageSvg svg={`icon-${icon}`} iconClass="icon--full" />
      </span>
    );
  };

  return (
    <div
      className={cx([
        'activityItem--padding',
        ['member--match', member.match],
        ['member--unseen', unseen],
      ])}
    >
      <div className="activityItem">
        <a href={`/member/${member._id}`} className="activityItem-link" />
        <div className="activityItem-actions mtm tss">
          <VoteButtons
            onVote={onVote}
            active={action}
            includeSkip={includeSkip}
            noAboLimitReached={noAboLimitReached}
          />
        </div>
        <div className="activityItem-image">
          {activityIcon()}
          <MemberImage
            member={member}
            memberId={member._id}
            type="s"
            key={member._id}
            hideIcons
          />
        </div>
        <div className="activityItem-wrapper">
          <span className="discussionComment-time">
            <Time
              date={updated}
              timeago
            />
          </span>
          <div className="activityItem-content">
            {myAction()}
          </div>
          <div className="activityItem-name">
            <div className="memberName">
              <MemberName
                key={member._id}
                member={member}
                memberId={member._id}
                truncate={17}
                hideAnswerScore
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
MatchesMembersItem.propTypes = {
  member: PropTypes.instanceOf(Object),
  action: PropTypes.string,
  updated: PropTypes.number,
  handleVote: PropTypes.func.isRequired,
  includeSkip: PropTypes.bool,
  unseen: PropTypes.bool,
  noAboLimitReached: PropTypes.bool,
};

MatchesMembersItem.defaultProps = {
  member: null,
  action: '',
  updated: null,
  includeSkip: false,
  unseen: false,
  noAboLimitReached: false,
};

export default MatchesMembersItem;
